/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as actions from './actions';
import * as api from './api';

export { actions, api };

export const ROUTE_PREFIX = '/sitepass';

export const MAX_PASSES_IN_CART = 10; // The maximum number of passes that can be in the cart (or in Order Details).

export const VehicleTypes = {
    'personal-vehicle': 'Personal Vehicle',
    'rental-vehicle': 'Rental Vehicle',
    'commercial-vehicle': 'Commercial Vehicle',
    'motor-coach': 'Motor Coach',
    'mini-bus': 'Mini Bus',
    van: 'Van',
    'no-vehicle': 'No Vehicle',
    camper: 'Camper',
};

export const WatercraftTypes = {
    'motorized-boat': 'Motorized Boat',
    'non-motorized-boat': 'Non-Motorized Boat',
    'rental-boat': 'Rental Boat',
    'no-boat': 'No Boat',
};

export const Durations = {
    annual: {
        name: 'Annual',
        validLength: '12 months',
        days: 365,
        endEndOfMonth: true,
    },
    '12-month': {
        name: 'Twelve Month',
        validLength: '12 Months',
        days: 365,
        endEndOfMonth: false,
    },
    semiannual: {
        name: 'Semiannual',
        validLength: '6 Months',
        days: 180,
        endEndOfMonth: true,
    },
    '6-month': {
        name: 'Six Month',
        validLength: '6 Months',
        days: 180,
        endEndOfMonth: false,
    },
    segment: {
        name: 'Segment',
        validLength: 'Flexible',
        days: -1,
        endEndOfMonth: false,
    },
    seasonal: {
        name: 'Seasonal',
        validLength: 'Seasonal',
        days: -1,
        endEndOfMonth: false,
    },
    season: {
        name: 'Seasonal',
        validLength: 'Seasonal',
        days: -1,
        endEndOfMonth: false,
    },
    '14-day': {
        name: 'Fourteen day',
        validLength: '14 Days',
        days: 14,
        endEndOfMonth: false,
    },
    '13-day': {
        name: 'Thirteen day',
        validLength: '13 Days',
        days: 13,
        endEndOfMonth: false,
    },
    '12-day': {
        name: 'Twelve day',
        validLength: '12 Days',
        days: 12,
        endEndOfMonth: false,
    },
    '11-day': {
        name: 'Eleven day',
        validLength: '11 Days',
        days: 11,
        endEndOfMonth: false,
    },
    '10-day': {
        name: 'Ten day',
        validLength: '10 Days',
        days: 10,
        endEndOfMonth: false,
    },
    '9-day': {
        name: 'Nine day',
        validLength: '9 Days',
        days: 9,
        endEndOfMonth: false,
    },
    '8-day': {
        name: 'Eight day',
        validLength: '8 Days',
        days: 8,
        endEndOfMonth: false,
    },
    '7-day': {
        name: 'Week',
        validLength: '7 Days',
        days: 7,
        endEndOfMonth: false,
    },
    '6-day': {
        name: 'Six day',
        validLength: '6 Days',
        days: 6,
        endEndOfMonth: false,
    },
    '5-day': {
        name: 'Five day',
        validLength: '5 Days',
        days: 5,
        endEndOfMonth: false,
    },
    '4-day': {
        name: 'Four day',
        validLength: '4 Days',
        days: 4,
        endEndOfMonth: false,
    },
    '3-day': {
        name: 'Three day',
        validLength: '3 Days',
        days: 3,
        endEndOfMonth: false,
    },
    '2-day': {
        name: 'Two day',
        validLength: '2 Days',
        days: 2,
        endEndOfMonth: false,
    },
    '1-day': {
        name: 'One day',
        validLength: '1 Day',
        days: 1,
        endEndOfMonth: false,
    },
    '14-day-offline': {
        name: 'Fourteen day',
        validLength: '14 Days',
        days: 14,
        endEndOfMonth: false,
    },
    '13-day-offline': {
        name: 'Thirteen day',
        validLength: '13 Days',
        days: 13,
        endEndOfMonth: false,
    },
    '12-day-offline': {
        name: 'Twelve day',
        validLength: '12 Days',
        days: 12,
        endEndOfMonth: false,
    },
    '11-day-offline': {
        name: 'Eleven day',
        validLength: '11 Days',
        days: 11,
        endEndOfMonth: false,
    },
    '10-day-offline': {
        name: 'Ten day',
        validLength: '10 Days',
        days: 10,
        endEndOfMonth: false,
    },
    '9-day-offline': {
        name: 'Nine day',
        validLength: '9 Days',
        days: 9,
        endEndOfMonth: false,
    },
    '8-day-offline': {
        name: 'Eight day',
        validLength: '8 Days',
        days: 8,
        endEndOfMonth: false,
    },
    '7-day-offline': {
        name: 'Week',
        validLength: '7 Days',
        days: 7,
        endEndOfMonth: false,
    },
    '6-day-offline': {
        name: 'Six day',
        validLength: '6 Days',
        days: 6,
        endEndOfMonth: false,
    },
    '5-day-offline': {
        name: 'Five day',
        validLength: '5 Days',
        days: 5,
        endEndOfMonth: false,
    },
    '4-day-offline': {
        name: 'Four day',
        validLength: '4 Days',
        days: 4,
        endEndOfMonth: false,
    },
    '3-day-offline': {
        name: 'Three day',
        validLength: '3 Days',
        days: 3,
        endEndOfMonth: false,
    },
    '2-day-offline': {
        name: 'Two day',
        validLength: '2 Days',
        days: 2,
        endEndOfMonth: false,
    },
    '1-day-offline': {
        name: 'One day',
        validLength: '1 Day',
        days: 1,
        endEndOfMonth: false,
    },
};

export const Features = [
    'accepted',
    'attendee-info',
    'day-segment',
    'discount',
    'equipment-info',
    'start-date',
];
export const Equipment = ['vehicle', 'watercraft'];

export const ReservationPointsOfSale = ['web', 'field'];
export const ReservationStatuses = ['pending', 'deleted', 'completed'];

export const ExpirationTypes = ['expired', 'refunded', 'voided'];

export default ROUTE_PREFIX;

// common date format strings
export const DATE_FORMAT_STANDARD = 'YYYY-MM-DD';
export const DATE_FORMAT_US_SLASHES = 'MM/DD/YYYY';

export const PRICE_MAGNITUDE = 100000;

export const MAX_GROUP_COUNT = 999;

export const INTERAGENCY_DISCOUNT_PASSES = [
    'Interagency Access Pass',
    'Interagency Annual Senior Pass',
    'Interagency Lifetime Senior Pass',
    'Golden Access Pass',
    'Golden Age Pass',
];

export const COUNT_OVERALL_GUESTS = ['74396'];

export const USE_BUTTON_INSTEAD_COUNTER = ['74396'];

// timed entry facility ids
export const ACADIA_FACILITY_ID = '400000';
export const GLACIER_FACILITY_ID = '10087086';
export const ROCKY_MOUNTAIN_SHUTTLE_FACILITY_ID = '10088647';
export const ROCKY_MOUNTAIN_FACILITY_ID = '10086910';
export const ARCHES_FACILITY_ID = '10088426';
export const LAVA_RIVER_CAVE_FACILITY_ID = '10089508';

// site pass ids
export const GLACIER_SITE_PASS_ID = '74280';
export const ROCKY_MOUNTAIN_SITE_PASS_ID = '74291';
export const DESCHUTES_SITE_PASS_ID = '74418';
export const ACADIA_SITE_PASS_ID = '74271';
export const ARCHES_SITE_PASS_ID = '74330';

// sitePass banner data
export const SITE_PASS_BANNERS = {
    [ROCKY_MOUNTAIN_SITE_PASS_ID]: {
        title: 'Book your timed entry reservation before you buy a pass!',
        description: 'A Timed Entry Reservation is required in the summer of 2025.',
        areaListTitle: ' ',
        areasWithReservation: [
            {
                name: 'Timed entry reservations for most areas of Rocky Mountain National Park will be in place from May 23 through October 13 between the hours of 9 am - 2 pm',
                dates: '',
            },
            {
                name: 'Timed entry reservations for Access to park + Bear Lake Road will be in place from May 23 through October 19 between the hours of 5 am - 6 pm',
                dates: '',
            },
        ],
        hideBookReservationButton: false,
        hideShowAvailablePassesButton: false,
        timedEntryFacilityId: ROCKY_MOUNTAIN_FACILITY_ID,
        showPassesByDefault: true,
    },
    [GLACIER_SITE_PASS_ID]: {
        title: 'Book your timed entry reservation before you buy a pass!',
        description: 'A Timed Entry Reservation is required in the summer of 2025..',
        areaListTitle: ' ',
        areasWithReservation: [
            {
                name: 'Timed entry reservations for the west side of Going-to-the-Sun Road will be in place from June 13 through September 28 between the hours of 7 am - 3 pm',
                dates: '',
            },
            {
                name: 'Timed entry reservations for the North Fork will be in place from June 13 through September 28 June between the hours of 7 am - 3 pm',
            },
        ],
        hideBookReservationButton: false,
        hideShowAvailablePassesButton: false,
        timedEntryFacilityId: GLACIER_FACILITY_ID,
        showPassesByDefault: false,
    },
    [ACADIA_SITE_PASS_ID]: {
        title: 'Book your vehicle reservation with your pass!',
        description:
            'A vehicle reservation is required to drive Cadillac Summit Road through October 22, 2023.',
        areasWithReservation: [],
        hideBookReservationButton: false,
        hideShowAvailablePassesButton: true,
        timedEntryFacilityId: ACADIA_FACILITY_ID,
        showPassesByDefault: true,
    },
    [ARCHES_SITE_PASS_ID]: {
        title: 'Book your timed entry reservation before you buy a pass!',
        description: 'A Timed Entry Reservation is required in the summer of 2025.',
        areaListTitle: ' ',
        areasWithReservation: [
            {
                name: 'Timed entry reservations for Arches National Park will be in place from April 1 through July 6 and again from August 28 through October 31 between the hours of 7 am and 4 pm',
                dates: '',
            },
        ],
        hideBookReservationButton: false,
        hideShowAvailablePassesButton: false,
        timedEntryFacilityId: ARCHES_FACILITY_ID,
        showPassesByDefault: false,
    },
    [DESCHUTES_SITE_PASS_ID]: {
        title: 'Book your timed reservation tickets with your pass!',
        description:
            'A timed reservation ticket is required to visit Lava River Cave between June 1st and September 15th',
        areasWithReservation: [],
        hideBookReservationButton: false,
        hideShowAvailablePassesButton: true,
        timedEntryFacilityId: LAVA_RIVER_CAVE_FACILITY_ID,
        showPassesByDefault: true,
    },
};

export const EXCLUDED_BANNERS_SITE_PASS_IDS = [
    ACADIA_SITE_PASS_ID,
    ARCHES_SITE_PASS_ID,
    ROCKY_MOUNTAIN_SITE_PASS_ID,
    GLACIER_SITE_PASS_ID,
];

// inter agency passes
export const INTERAGENCY_ANNUAL_PASS = 'INTERAGENCY_ANNUAL_PASS';
export const INTERAGENCY_ANNUAL_SENIOR_PASS = 'INTERAGENCY_ANNUAL_SENIOR_PASS';
export const INTERAGENCY_LIFETIME_SENIOR_PASS = 'INTERAGENCY_LIFETIME_SENIOR_PASS';
export const INTERAGENCY_ACCESS_PASS = 'INTERAGENCY_ACCESS_PASS';
export const INTERAGENCY_VOLUNTEER_PASS = 'INTERAGENCY_VOLUNTEER_PASS';
export const INTERAGENCY_MILITARY_PASS = 'INTERAGENCY_MILITARY_PASS';
export const INTERAGENCY_LIFETIME_MILITARY_PASS = 'INTERAGENCY_LIFETIME_MILITARY_PASS';
export const INTERAGENCY_GOLDEN_AGE_PASS = 'INTERAGENCY_GOLDEN_AGE_PASS';
export const INTERAGENCY_GOLDEN_ACCESS_PASS = 'INTERAGENCY_GOLDEN_ACCESS_PASS';

export const INTERAGENCY_PASSES_MAP = {
    [INTERAGENCY_ANNUAL_PASS]: {
        altText: 'annual pass',
        fileName: 'annual-pass',
        fallbackExtension: 'png',
    },
    [INTERAGENCY_ANNUAL_SENIOR_PASS]: {
        altText: 'annual senior pass',
        fileName: 'senior-annual-pass',
        fallbackExtension: 'png',
    },
    [INTERAGENCY_LIFETIME_SENIOR_PASS]: {
        altText: 'lifetime senior pass',
        fileName: 'senior-lifetime-pass',
        fallbackExtension: 'jpg',
    },
    [INTERAGENCY_ACCESS_PASS]: {
        altText: 'access pass',
        fileName: 'access-pass',
        fallbackExtension: 'jpg',
    },
    [INTERAGENCY_VOLUNTEER_PASS]: {
        altText: 'volunteer pass',
        fileName: 'volunteer-pass',
        fallbackExtension: 'png',
    },
    [INTERAGENCY_MILITARY_PASS]: {
        altText: 'military pass',
        fileName: 'military-pass',
        fallbackExtension: 'png',
    },
    [INTERAGENCY_LIFETIME_MILITARY_PASS]: {
        altText: 'lifetime military pass',
        fileName: 'military-lifetime',
        fallbackExtension: 'png',
    },
    [INTERAGENCY_GOLDEN_AGE_PASS]: {
        altText: 'golden age pass',
        fileName: 'golden-age-pass',
        fallbackExtension: 'jpg',
    },
    [INTERAGENCY_GOLDEN_ACCESS_PASS]: {
        altText: 'golden access pass',
        fileName: 'golden-access-pass',
        fallbackExtension: 'jpg',
    },
};

export const INTERAGENCY_PASSES = [
    INTERAGENCY_ANNUAL_PASS,
    INTERAGENCY_ANNUAL_SENIOR_PASS,
    INTERAGENCY_LIFETIME_SENIOR_PASS,
    INTERAGENCY_ACCESS_PASS,
    INTERAGENCY_VOLUNTEER_PASS,
    INTERAGENCY_MILITARY_PASS,
    INTERAGENCY_LIFETIME_MILITARY_PASS,
    INTERAGENCY_GOLDEN_AGE_PASS,
    INTERAGENCY_GOLDEN_ACCESS_PASS,
];

export const TRANSPORTATION_TYPE = {
    vehicle: {
        order: 1,
    },
    motorcycle: {
        order: 2,
    },
    individual: {
        order: 3,
    },
    all: {
        order: 9999,
    },
};
